/* global loadRecaptchaWithoutDefence */
/* eslint-disable object-curly-spacing */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from '../../../common/Button';
import H from '../../../common/Typography/H';
import P from '../../../common/Typography/P';
import renderTextField from './render-text-field';
import renderPhoneField from './render-phone-field';
import renderFileInput from './render-file-input';
import validate, { FORM_NAME, syncValidSelector } from './validation';

import styles from './service-form.module.scss';

function ServiceForm({
  handleSubmit,
  onRequestClose,
  error,
  submitFailed,
  submitSucceeded,
  submitting,
  syncValid,
  siteKey
}) {
  const [submitAgain, setSubmitAgain] = useState(false);

  useEffect(() => {
    if (submitAgain) {
      loadRecaptchaWithoutDefence();
    }
  }, [submitAgain]);

  if (submitSucceeded && syncValid && !submitAgain) {
    return (
      <div className={styles.root}>
        <H level={3} className={styles.title}>
          Отправлено
        </H>
        <P>Спасибо! Мы свяжемся с вами в течение дня</P>
        <div className={styles.footer}>
          <Button
            variant="contained"
            style="secondary"
            component="span"
            onClick={onRequestClose}
          >
            Закрыть
          </Button>
        </div>
      </div>
    );
  } else if (submitFailed && error && !submitAgain) {
    return (
      <div className={styles.root}>
        <H level={3} className={styles.title}>
          Произошла ошибка
        </H>
        <P>{error}</P>
        <div className={styles.footer}>
          <Button
            variant="contained"
            style="secondary"
            component="span"
            onClick={() => setSubmitAgain(true)}
          >
            Попробовать ещё раз
          </Button>
        </div>
      </div>
    );
  } else {
    return (
      <form
        className={styles.root}
        encType="multipart/form-data"
        onSubmit={(event) => {
          event.preventDefault();

          handleSubmit();
          setSubmitAgain(false);
        }}
      >
        <H level={3} className={styles.title}>
          Обратная связь
        </H>
        <div className={styles.row}>
          <Field name="name" component={renderTextField} label="Ваше имя" />
        </div>
        <div className={styles.row}>
          <Field
            name="phone"
            component={renderPhoneField}
            label="Телефон *"
            required
          />
        </div>
        <div className={styles.row}>
          <Field
            name="email"
            component={renderTextField}
            label="Эл. почта *"
            required
          />
        </div>
        <div className={styles.row}>
          <Field
            name="notes"
            component={renderTextField}
            label="Подробности заказа"
            multiline={true}
            rows={2}
          />
        </div>
        <div className={styles.fileUpload}>
          <Field
            name="link"
            component={renderTextField}
            label="Ссылка на файл"
          />
          <span className={styles.separator}>или</span>
          <Field
            name="file"
            component={renderFileInput}
            className={styles.fileButton}
          />
        </div>
        <div className="g-recaptcha" data-sitekey={siteKey}></div>
        <div className={styles.footer}>
          <Button
            type="submit"
            disabled={!syncValid || submitting}
            variant="contained"
            style="primary"
            size="large"
          >
            Отправить
          </Button>
          <div className={styles.disclaimer}>
            Нажимая «Отправить», вы соглашаетесь с правилами пользования и
            политикой конфиденциальности
          </div>
        </div>
      </form>
    );
  }
}

ServiceForm.propTypes = {
  handleSubmit: PropTypes.func,
  onRequestClose: PropTypes.func,
  error: PropTypes.string,
  submitFailed: PropTypes.bool,
  submitSucceeded: PropTypes.bool,
  submitting: PropTypes.bool,
  syncValid: PropTypes.bool,
  siteKey: PropTypes.string
};

const ConnectedServiceForm = connect((state) => ({
  syncValid: syncValidSelector(state)
}))(ServiceForm);

export default reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  validate
})(ConnectedServiceForm);
